import React from 'react';
import '../App.css';
import CharacterSheet from './CharacterSheet';
import Feats from './Feats';
import Spells from './Spells';
import Inventory from './Inventory';
import Combat from './Combat';
import Traits from './Traits';
import Notes from './Notes';
import { useCharacter } from '../hooks/useCharacter';
import { useAuth } from '../context/AuthContext';
import AppLogo from '../assets/logoTypography.png';

const SPELLCASTERS = ['Bard', 'Cleric', 'Druid', 'Paladin', 'Ranger', 'Sorcerer', 'Warlock', 'Wizard', 'Artificer'];



const Tracker = () => {
    const { character, updateCharacter, toggleFeat, toggleSpell, computedFeats, inventoryActions, updateResource, updateFeatureChoice, updateFeatChoice, updateProficiency, rest, toggleCondition, isSaving, isRemoteLoading } = useCharacter();
    const [activeTab, setActiveTab] = React.useState('sheet');
    const { logout, user } = useAuth();

    const isSpellcaster = SPELLCASTERS.includes(character.class) || (character.spells && (character.spells.prepared.length > 0 || character.spells.known.length > 0));

    return (
        <div className="App">
            <header className="App-header">
                <div className="header-content">
                    {/* Left: Logo */}
                    <div className="logo-container">
                        <img src={AppLogo} alt="MythosTracker" className="app-logo" />
                    </div>

                    {/* Center: Navigation Stack */}
                    <nav className="nav-container">
                        <div className="nav-stack">
                            <div className="nav-row">
                                <button
                                    className={`tab-button ${activeTab === 'sheet' ? 'active' : ''}`}
                                    onClick={() => setActiveTab('sheet')}
                                >
                                    Character Sheet
                                </button>
                                <button
                                    className={`tab-button ${activeTab === 'notes' ? 'active' : ''}`}
                                    onClick={() => setActiveTab('notes')}
                                >
                                    Notes
                                </button>
                                <button
                                    className={`tab-button ${activeTab === 'combat' ? 'active' : ''}`}
                                    onClick={() => setActiveTab('combat')}
                                >
                                    Combat
                                </button>
                            </div>
                            <div className="nav-row">
                                <button
                                    className={`tab-button ${activeTab === 'inventory' ? 'active' : ''}`}
                                    onClick={() => setActiveTab('inventory')}
                                >
                                    Inventory
                                </button>
                                <button
                                    className={`tab-button ${activeTab === 'traits' ? 'active' : ''}`}
                                    onClick={() => setActiveTab('traits')}
                                >
                                    Traits
                                </button>
                                <button
                                    className={`tab-button ${activeTab === 'feats' ? 'active' : ''}`}
                                    onClick={() => setActiveTab('feats')}
                                >
                                    Feats
                                </button>
                            </div>
                        </div>

                        {/* Right of Stack: Spells */}
                        {isSpellcaster && (
                            <div className="spells-container">
                                <button
                                    className={`tab-button ${activeTab === 'spells' ? 'active' : ''}`}
                                    onClick={() => setActiveTab('spells')}
                                >
                                    Spells
                                </button>
                            </div>
                        )}
                    </nav>

                    {/* Far Right: User Info */}
                    <div className="user-info">
                        {isSaving && <span className="status-saving">Saving...</span>}
                        {isRemoteLoading && <span className="status-loading">Loading...</span>}
                        <span className="welcome-text">Welcome, {user && user.username}</span>
                        <button onClick={logout} className="logout-button">Logout</button>
                    </div>
                </div>
            </header>
            <main className="App-content">
                {activeTab === 'sheet' && (
                    <CharacterSheet
                        character={character}
                        updateCharacter={updateCharacter}
                        inventoryActions={inventoryActions}
                        updateProficiency={updateProficiency}
                    />
                )}
                {activeTab === 'notes' && (
                    <Notes character={character} updateCharacter={updateCharacter} />
                )}
                {activeTab === 'combat' && (
                    <Combat
                        character={character}
                        proficiencyBonus={character.proficiencyBonus}
                        updateResource={updateResource}
                        rest={rest}
                        toggleCondition={toggleCondition}
                    />
                )}
                {activeTab === 'inventory' && (
                    <Inventory
                        character={character}
                        inventoryActions={inventoryActions}
                        proficiencyBonus={character.proficiencyBonus}
                    />
                )}
                {activeTab === 'traits' && (
                    <Traits
                        character={character}
                        updateCharacter={updateCharacter}
                        updateFeatureChoice={updateFeatureChoice}
                        computedFeats={computedFeats}
                    />
                )}
                {activeTab === 'feats' && (
                    <Feats
                        character={character}
                        toggleFeat={toggleFeat}
                        computedFeats={computedFeats}
                        updateFeatChoice={updateFeatChoice}
                    />
                )}

                {activeTab === 'spells' && isSpellcaster && (
                    <Spells character={character} toggleSpell={toggleSpell} />
                )}
            </main>
        </div>
    );
};

export default Tracker;
